'use client';

import { MatchModelUnion, SportMatchModel } from '@nf/types/odds';
import { Team, Vs } from '../match-item';
import { Scoreboard, ScoreboardSportId } from '../scoreboard';
import { scoreboardService } from '@/services/scoreboard.service';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { VolumeOffIcon, VolumeOnIcon } from '@/components/icons/svg-icons';
import { Button } from '@nf/ui';
import { streamingService } from '@/services/streaming.service';
import { useAccountInfo } from '@/hooks/query/account';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useSingleMatchFilter } from '@/features/single-match/bet-types-section/contexts/single-match-filter-context';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KafkaNote } from '@nf/utils-common/constants';
import { MyFavouritesMatchButton } from '@/features/my-favourites/components/my-favourites-match-button';
import { StatisticButton } from '@/components/feature-buttons/statistic-button';
import { MatchInfoStyles } from './matchpanel-info.style';
import { cx } from 'styled-system/css';

export interface MatchInfoPanelProps {
	match: SportMatchModel;
	home: string;
	away: string;
	isStreamingPlugin?: boolean;
}

export const MatchInfoPanel = ({ match, home, away, isStreamingPlugin }: MatchInfoPanelProps) => {
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const { isMute, setIsMute } = useSingleMatchFilter();
	const homeScoreList = scoreboardService.getMatchCricketScore(match, 'home');
	const awayScoreList = scoreboardService.getMatchCricketScore(match, 'away');
	const { hasOtherScoreboard } = scoreboardService.getScoreboardInfo(match);
	const view = useAppearanceStore(state => state.view);
	const { hasVideo, hasStreamer } = streamingService.getVideoOptions(match as MatchModelUnion, false, SiteConfigsData, user);

	const toggleIsMute = () => {
		if (view === ViewEnum.mars) {
			const kafkaData = {
				note: KafkaNote.MarsV1,
				type: 6,
				action: 28
			}
			setKafkaNormal(kafkaData);
		}
		setIsMute(!isMute);
	}

	if (!match) {
		return;
	}

	const {
		MatchId,
		Ktm,
		Etm,
		GameID
	} = match;

	return (
		<div className={cx(`video-lobby video-lobby--sport${GameID}`, MatchInfoStyles.lobby)}>
			
			<div className={MatchInfoStyles.buttonsTop}>
				{
					view === ViewEnum.mars ? (
						<>
							{match?.GameID !== 50 ? (
								<StatisticButton match={match} isNeedSetMatchId={false} home={home} away={away} />
							): null}
							<MyFavouritesMatchButton matchId={MatchId} time={Ktm || Etm} sportType={GameID} />
						</>
					) : null
				}
			</div>
			<div className="video-match">
				{match?.GameID !== 50 ? (
					<>
						<Team
							imgType="H"
							name={home}
							sportId={match?.GameID}
						/>
						<Vs match={match} />
						<Team
							imgType="A"
							name={away}
							sportId={match?.GameID}
						/>
					</>
				) : (
					<>
						<Team
							imgType="H"
							name={home}
							scoreList={homeScoreList}
							sportId={match?.GameID}
						/>
						<Vs match={match} />
						<Team
							imgType="A"
							name={away}
							scoreList={awayScoreList}
							sportId={match?.GameID}
						/>
					</>
				)}
			</div>
			{
				hasOtherScoreboard ?
					<Scoreboard
						key={`${match?.GameID}MatchInfoPanel`}
						sportId={match?.GameID as ScoreboardSportId}
						matchModelData={match}
					/> : null
			}
			<div className={MatchInfoStyles.buttonsBottom}>
				{ user?.ActStatus ===2 && view === ViewEnum.mars && (hasStreamer || hasVideo) && !isStreamingPlugin ? (
				
					<Button
						variant="icon"
						className="btn--mute"
						onClick={toggleIsMute}
					>
						{
							isMute ? <VolumeOffIcon /> : <VolumeOnIcon />
						}
					</Button>
				) : null
				}
			</div>
		</div>
	);
}